import isEqual from 'lodash.isequal';
import { ICartAddItemParams } from 'entities/Cart/Cart.models';

export const getCartItemTotalSum = (item: ICartAddItemParams, discountPrice?: number | null): number => {
  const { price, quantity } = item;
  const calcPrice = discountPrice || price;
  const itemSum = calcPrice * quantity;
  const addOnsSum =
    item?.addOns?.reduce((acc, current) => {
      const { quantity: addOnQuantity, price: addOnPrice } = current;
      acc += addOnQuantity * addOnPrice * quantity;
      return acc;
    }, 0) || 0;
  const mealBuilderSum = item.mealBuilderPicks.reduce((acc, pick) => acc + pick.price * pick.quantity * quantity, 0);

  return itemSum + addOnsSum + mealBuilderSum;
};

export const isCartAddItemParamsEquals = (first: ICartAddItemParams, second: ICartAddItemParams): boolean => {
  const sortById = (a: { menuItemId: string }, b: { menuItemId: string }) => a.menuItemId.localeCompare(b.menuItemId);
  const normalize = (item: ICartAddItemParams) => ({
    ...item,
    addOns: [...item.addOns].sort(sortById),
    mealBuilderPicks: [...item.mealBuilderPicks].sort(sortById),
  });
  return isEqual(normalize(first), normalize(second));
};
